import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { default as React } from 'react';
import { Loading } from 'react-loading-ui';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as constants from '../Constants';
import environment from '../environments/environment';
import CancelModalComponent from '../popUpModals/CancelModalComponent';
import SubmitModalComponent from '../popUpModals/SubmitModalComponent';
import './../App.css';

class TransferCases extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            shows: false,
            reDirect: '',
            tcoOption: '',
            supervisor: '',
            fromAttorney: '',
            toAttorney: '',
            supervisors: [],
            attorneys: [],
            caseList: [],
            email: '',
            userRole: '',
            toAttorneyName: '',
            atOption: '',
            toSupervisor: '',
            toSupervisorName: '',
            maTranferCases: [],
            errorSupervisorNameMessage: "",
            errorAttorneyNameMessage: "",
            refreshFlage: true,
            totalItems: '',
        }
    }
    componentDidMount = async () => {
        if (this.props.userStatus.userName !== "") {
            this.setState({
                email: this.props.userStatus.emailId,
                userRole: this.props.userStatus.userRole,
                supervisor: this.props.userStatus.userId,
            }, () => {
                this.getSupervisor(this.state.supervisor);
            })
        } else {
            this.setState({
                reDirect: '/',
            })
        }
    }
    getSupervisor(value) {
        axios.get(environment.getAllSupervisors)
            .then(response => {
                if (response.data !== null) {
                    this.setState({
                        supervisors: response.data,
                    });
                    if (value > 0) {
                        this.getAttorney(value);
                    }
                }
            })
    }
    getAttorney(value) {
        Loading();
        axios.get(environment.getAllAttorneys + value)
            .then(response => {
                if (response.data !== null) {
                    if ((this.state.userRole === 'Admin' || this.state.atOption === 'spvr') && this.state.atOption !== 'atny' ) {
                        this.setState({
                            attorneys: response.data,
                            fromAttorney: 0
                        }, () => {
                            this.getCaseInfoList();
                        });
                    } else {
                        this.setState({
                            attorneys: response.data,
                            fromAttorney: response.data[0].attorneyId
                        }, () => {
                            this.getCaseInfoList();
                        });
                    }
                }
                setTimeout(() => {
                    Loading();
                });
            })
    }
    onChangeTCO = (event) => {
        this.setState({
            tcoOption: event.target.value,
        }, () => {
            if (this.state.userRole === 'Admin') {
                this.getSupervisor(this.state.supervisor);
            } else {
                this.getCaseInfoList();
            }
        });
    }
    onChangeAT = (event) => {
        this.setState({
            atOption: event.target.value,
        }, () => {
            if (event.target.value === "spvr") {
                this.getCaseInfoList();
            }
        });
    }
    changeFromAttorney = (event) => {
        this.setState({
            fromAttorney: event.target.value,
            caseList: [],
            maTranferCases: []
        }, () => {
            this.getCaseInfoList();
            this.toValiadetAttorney();
        });
    }
    changeAttorney = (event) => {
        this.setState({
            fromAttorney: event.target.value,
            caseList: [],
            maTranferCases: []
        }, () => {
            this.getCaseInfoList();
            this.toValiadetSuperviserAttorney();
        });
    }
    toValiadetSuperviserAttorney() {
        if (this.state.supervisor == this.state.fromAttorney) {
            this.setState({
                errorAttorneyNameMessage: "Cannot perform this action with the same Attorney.",
            })
        } else {
            this.setState({
                errorAttorneyNameMessage: "",
            })
        }
    }
    changeToAttorney = (event) => {
        const found = this.state.attorneys.find((item) => item.attorneyId == event.target.value);
        this.setState({
            toAttorney: event.target.value,
            toAttorneyName: event.target.value === ""?"":found.attorneyName,
        }, () => {
            this.toValiadetAttorney();
        });
    }
    toValiadetAttorney() {
        if (this.state.fromAttorney == this.state.toAttorney) {
            this.setState({
                errorAttorneyNameMessage: "Cannot perform this action with the same Attorney.",
            })
        } else {
            this.setState({
                errorAttorneyNameMessage: "",
            })
        }
    }
    spvrChangeValue = (event) => {
        this.setState({
            supervisor: event.target.value,
            toAttorney: '',
            errorAttorneyNameMessage: "",
            caseList: [],
            maTranferCases: [],
        }, () => {
            if (event.target.value > 0) {
                this.getAttorney(event.target.value);
            }
            this.getCaseInfoList();
        });
        this.toValiadetspvr();
    }
    spvrTochangeValue = (event) => {
        const found = this.state.supervisors.find((item) => item.supervisorId == event.target.value);
        this.setState({
            toSupervisor: event.target.value,
            toSupervisorName:  event.target.value === ""?"":found.supervisor,
        }, () => {
            this.toValiadetspvr();
        });
    }
    toValiadetspvr() {
        this.setState({
            errorSupervisorNameMessage: "",
        }, () => {
            if (this.state.supervisor == this.state.toSupervisor) {
                this.setState({
                    errorSupervisorNameMessage: "Cannot perform this action with the same Supervisor.",
                })
            } else {
                this.setState({
                    errorSupervisorNameMessage: "",
                })
            }
        })
    }

    changeCaseToAttorney = (event, cases, index) => {
        event.preventDefault();
        if (this.state.maTranferCases.length == 0) {
            let bulkCaseTransfer = {};
            bulkCaseTransfer.caseId = cases.caseId;
            bulkCaseTransfer.newSupervisor = null;
            bulkCaseTransfer.newAttorney = event.target.value;
            this.state.maTranferCases.push(bulkCaseTransfer);
            this.state.caseList[index].selectedAttorney = event.target.value;
        } else {
            const found = this.state.maTranferCases.find((item) => item.caseId == cases.caseId);
            if (found == null) {
                let bulkCaseTransfer = {};
                bulkCaseTransfer.caseId = cases.caseId;
                bulkCaseTransfer.newSupervisor = null;
                bulkCaseTransfer.newAttorney = event.target.value;
                this.state.maTranferCases.push(bulkCaseTransfer);
                this.state.caseList[index].selectedAttorney = event.target.value;
            } else {
                if (event.target.value != "") {
                    found.newAttorney = event.target.value;

                } else {
                    this.state.maTranferCases.splice(this.state.maTranferCases.findIndex((item) => item.caseId == cases.caseId), 1);
                }
                this.state.caseList[index].selectedAttorney = event.target.value;
            }
        }
        this.toValiadetnewAttorney(cases, index);
    }
    toValiadetnewAttorney(cases, index) {
        if (cases.attorneyId == cases.selectedAttorney) {
            this.state.caseList[index].errorNewAttorneyNameMessage = "Cannot perform this action with the same Attorney.";
        } else {
            this.state.caseList[index].errorNewAttorneyNameMessage = "";
        }
        this.setState({
            refreshFlage: true,
        })
    }
    getCaseInfoList() {
        Loading();
        let casesearch = {};
        casesearch.attorneyName = this.state.fromAttorney;
        casesearch.supervisor = this.state.supervisor;
        if (this.state.atOption === 'spvr' && this.state.fromAttorney == 0) {
            casesearch.attorneyId = "";
        } else {
            casesearch.attorneyId = this.state.fromAttorney;
        }
        casesearch.supervisorId = this.state.supervisor;
        casesearch.mailId = this.state.email;
        casesearch.userRole = this.state.userRole;
        casesearch.statusFlag = constants.OPTION_ALL;
        casesearch.status = constants.IS_ACTIVE_YES;
        casesearch.pageNo = -1;
        casesearch.pageSize = 0;
        axios.post(environment.getCaseInfoList, casesearch)
            .then(response => {
                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    this.setState({
                        caseList: response.data.caseVOList,
                        totalItems: response.data.apiResponseVO.recCount,
                    });
                    setTimeout(() => {
                        Loading();
                    });
                } else {
                    this.setState({
                        totalItems: 0,
                        caseList: null,
                    })
                    // toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER });
                    setTimeout(() => {
                        Loading();
                    });
                }

            })
            .catch((error) => {
                //toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
            });
    }
    showModal = () => {
        this.setState({ show: true });
    };
    onCloseModal() {
        this.setState({ show: false });
    };
    onCancelChanges() {
        this.setState({
            reDirect: "/caseSummary"
        })
    };
    onSubmitModal() {
        this.setState({ shows: false });
    };
    onSubmitChanges() {
        this.onSubmitModal();
        this.toSave();
    }
    async onSubmit(event) {
        event.preventDefault();
        if (this.state.caseList != null && this.state.caseList.length > 0) {
            if ((this.state.userRole === 'Supervisor' || this.state.atOption === 'atny') && this.state.tcoOption === "one" &&
                this.state.errorAttorneyNameMessage === "" && this.state.toAttorney != "" && this.state.fromAttorney != "" && this.state.supervisor != "") {
                this.setState({ shows: true });
            } else if ((this.state.userRole === 'Supervisor' || this.state.atOption === 'atny') && this.state.tcoOption === "multiple" &&
                this.state.fromAttorney != "" && this.state.supervisor != "" && this.state.maTranferCases.length > 0) {
                let count = await this.validateMultipleAttorneyList();
                if (count > 0 && count == this.state.maTranferCases.length) {
                    this.setState({ shows: true });
                } else {
                    toast.error("Please select the values to submit a request.", { position: toast.POSITION.TOP_CENTER })
                }
            } else if (this.state.userRole === 'Admin' && this.state.atOption === 'spvr' &&
                this.state.errorSupervisorNameMessage === "" && this.state.errorAttorneyNameMessage === "" && this.state.toSupervisor != "" && this.state.supervisor != "") {
                this.setState({ shows: true });
            } else {
                toast.error("Please select the values to submit a request.", { position: toast.POSITION.TOP_CENTER })
            }
        } else {
            if ((this.state.userRole === 'Admin' && this.state.atOption === "") || ((this.state.userRole === 'Supervisor' || this.state.atOption === 'atny') && this.state.tcoOption === "")) {
                toast.error("Please select at least one option before submitting your request.", { position: toast.POSITION.TOP_CENTER })
            } else {
                toast.error("No Records found to submit a request.", { position: toast.POSITION.TOP_CENTER })
            }
        }

    }
    async validateMultipleAttorneyList() {
        let count = 0;
        for (let transferCases of this.state.caseList) {
            if (transferCases.errorNewAttorneyNameMessage == "") {
                count++;
            }
        }
        return await count;
    }
    toSave() {
        Loading();
        let caseTransferRequest = {};
        if ((this.state.userRole === 'Supervisor' || this.state.atOption === 'atny') && this.state.tcoOption === "one") {
            caseTransferRequest.supervisor = this.state.supervisor;
            caseTransferRequest.attorney = this.state.fromAttorney;
            caseTransferRequest.newSupervisor = null;
            caseTransferRequest.newAttorney = this.state.toAttorney;
            caseTransferRequest.cases = null;
            caseTransferRequest.username = this.state.email;
        } else if ((this.state.userRole === 'Supervisor' || this.state.atOption === 'atny') && this.state.tcoOption === "multiple") {
            caseTransferRequest.supervisor = this.state.supervisor;
            caseTransferRequest.attorney = this.state.fromAttorney;
            caseTransferRequest.newSupervisor = null;
            caseTransferRequest.newAttorney = null;
            caseTransferRequest.cases = this.state.maTranferCases;
            caseTransferRequest.username = this.state.email;
        } else if (this.state.userRole === 'Admin' && this.state.atOption === 'spvr') {
            caseTransferRequest.supervisor = this.state.supervisor;
            if (this.state.fromAttorney != 0) {
                caseTransferRequest.attorney = this.state.fromAttorney;
            } else {
                caseTransferRequest.attorney = null;
            }
            caseTransferRequest.newSupervisor = this.state.toSupervisor;
            caseTransferRequest.newAttorney = null;
            caseTransferRequest.cases = null;
            caseTransferRequest.username = this.state.email;
        }
        axios.post(environment.casesTransfers, caseTransferRequest)
            .then(response => {
                if (response.data.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    this.setState({ reDirect: '/caseSummary' })
                    setTimeout(() => {
                        Loading();
                    });
                    toast.success(response.data.message,
                        { position: toast.POSITION.TOP_CENTER }
                    )
                } else {
                    toast.error(response.data.message, { position: toast.POSITION.TOP_CENTER })
                    this.setState({ reDirect: '/caseSummary' })
                    setTimeout(() => {
                        Loading();
                    });
                }
            })
            .catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
                this.setState({ reDirect: '/caseSummary' })
                setTimeout(() => {
                    Loading();
                });
            });
    }
    render() {
        if (this.state.reDirect) {
            return <Redirect to={this.state.reDirect} />
        }
        return (
            <React.Fragment>
                <ToastContainer style={{ marginTop: '7%' }} />
                <form onSubmit={(event) => this.onSubmit(event)}>
                    <div className="container pl-0  pr-0 ">
                        <h4>Transfer Case(s)</h4>
                        <hr></hr>
                        {this.state.userRole === 'Admin' && <div className='row'>
                            {/* <div className=' col-3'><h6>Select Type of Transfer</h6></div>
                            <div className=' col-1'>:</div> */}
                            <div className=' col-3'>
                                <label style={{ marginLeft: '25%', textAlign: 'right' }}> <b>Select Type of Transfer</b><span className="required"></span>
                                    <b className="float-right " style={{ width: '5%' }}>:</b>
                                </label></div>
                            <div className=' col-8' onChange={this.onChangeAT}>
                                <input className="form-check-input" id="spvrId" type="radio" name="at" value="spvr" style={{ marginTop: "5px", marginRight: "10px" }} />
                                <label className="form-check-label" for="spvrId">Supervisors Transfer </label>
                                <br />
                                <input className="form-check-input" id="atnyId" type="radio" name="at" value="atny" style={{ marginTop: "5px", marginRight: "10px" }} />
                                <label className="form-check-label" for="atnyId">Attorneys Transfer </label>
                            </div>
                        </div>}
                        {this.state.atOption === 'spvr' && <div className='row'>
                            <div className='row'>
                                <div className="form-group mt-1 col"  >
                                    <label className="col"> <b>Supervisor</b>
                                        <b className="float-left " style={{ width: '5%' }}>:</b>
                                    </label>&nbsp;<select name="supervisor" value={this.state.supervisor} onChange={this.spvrChangeValue}  style={{ width: '200px' }} >
                                        <option value="">Select</option>
                                        {this.state.supervisors.map((supervisor) => (
                                            <option key={supervisor.supervisorId} value={supervisor.supervisorId}
                                            >{supervisor.supervisor}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group mt-1 col"  >
                                    <label className=" col"> <b>Attorney </b>
                                        <b className="float-right " style={{ width: '5%' }}>:</b>
                                    </label>&nbsp;
                                    <select name="attorney" value={this.state.fromAttorney} onChange={this.changeAttorney}  style={{ width: '200px' }} >
                                        <option value="0">All</option>
                                        {this.state.attorneys.map((attorney) => (
                                            <option key={attorney.attorneyId} value={attorney.attorneyId}
                                            >{attorney.attorneyName}</option>
                                        ))}
                                    </select>
                                    <p className="text-danger" style={{ marginLeft: '21%' }}>{this.state.errorAttorneyNameMessage}</p>
                                </div>
                                <div className="form-group mt-1 col"  >
                                    <label className="col"> <b>To Supervisor</b>
                                        <b className="float-left " style={{ width: '5%' }}>:</b>
                                    </label>&nbsp;<select name="tosupervisor" value={this.state.toSupervisor} onChange={this.spvrTochangeValue} style={{ width: '200px' }} >
                                        <option value="">Select</option>
                                        {this.state.supervisors.map((supervisor) => (
                                            this.state.supervisor != supervisor.supervisorId && <option key={supervisor.supervisorId} value={supervisor.supervisorId}
                                            >{supervisor.supervisor}</option>
                                        ))}
                                    </select>
                                    <p className="text-danger" style={{ marginLeft: '21%' }}>{this.state.errorSupervisorNameMessage}</p>
                                </div>
                            </div>
                            <div className='row pt-3'>
                                <div className="dashboard">
                                    <table className="table table-bordered table-condensed table-striped table-hover table-sm" id="table-dashboard">
                                        <thead className="color">
                                            <tr style={{ borderStyle: 'hidden' }}>
                                                <th width="25%">Case Name </th>
                                                <th width="25%">Supervisor</th>
                                                <th width="25%">Attorney</th>
                                                <th width="25%">To Supervisor </th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ borderStyle: 'hidden' }}  >
                                            {this.state.caseList != null && this.state.caseList.map((cases, index) => (
                                                <tr key={index}>
                                                    <td width="25%">{cases.caseName}</td>
                                                    <td width="25%">{cases.supervisorName}</td>
                                                    <td width="25%">{cases.attorneyName}</td>
                                                    <td width="25%">{this.state.toSupervisorName}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {this.state.totalItems === 0 && <p> No Records are Found.</p>}
                            </div>
                        </div>}
                        {(this.state.userRole === 'Supervisor' || this.state.atOption === 'atny') && <div className='row'>
                            {/* <div className=' col-3'><h6>Select Mode</h6></div>
                            <div className=' col-1'>:</div> */}
                            <div className=' col-3'>
                                <label style={{ marginLeft: '54%', textAlign: 'right' }}> <b>Select Mode</b><span className="required"></span>
                                    <b className="float-right " style={{ width: '5%' }}>:</b>
                                </label></div>
                            <div className=' col-8' onChange={this.onChangeTCO}>&nbsp;&nbsp;&nbsp;&nbsp;
                                <input className="form-check-input" id="oneId" type="radio" name="tco" value="one" style={{ marginTop: "5px", marginRight: "10px" }} />
                                <label className="form-check-label" for="oneId">One to other Attorney </label>
                                <br />
                                &nbsp;&nbsp;&nbsp;&nbsp;<input className="form-check-input" id="multipleId" type="radio" name="tco" value="multiple" style={{ marginTop: "5px", marginRight: "10px" }} />
                                <label className="form-check-label" for="multipleId">One to Multiple Attorneys </label>
                            </div>
                        </div>}
                        {this.state.tcoOption !== '' && (this.state.atOption === 'atny' || this.state.atOption === '') &&
                            <div className='row'>
                                <div className='row'>
                                    <div className="form-group mt-1 col"  >
                                        <label className="col"> <b>Supervisor</b>
                                            <b className="float-left " style={{ width: '5%' }}>:</b>
                                        </label>&nbsp;
                                        {this.state.userRole === 'Admin' ? <select name="supervisor" value={this.state.supervisor} onChange={this.spvrChangeValue} style={{ width: '200px' }} >
                                            <option value="">Select</option>
                                            {this.state.supervisors.map((supervisor) => (
                                                <option key={supervisor.supervisorId} value={supervisor.supervisorId}
                                                >{supervisor.supervisor}</option>
                                            ))}
                                        </select> :
                                            <select disabled name="supervisor" value={this.state.supervisor} onChange={this.spvrChangeValue} style={{ width: '200px' }} >
                                                <option value="">Select</option>
                                                {this.state.supervisors.map((supervisor) => (
                                                    <option key={supervisor.supervisorId} value={supervisor.supervisorId}
                                                    >{supervisor.supervisor}</option>
                                                ))}
                                            </select>}
                                    </div>
                                    <div className="form-group  mt-1 col" >
                                        <label className=" col"> <b>From Attorney </b>
                                            <b className="float-right " style={{ width: '5%' }}>:</b>
                                        </label>&nbsp;
                                        <select name="attorney" value={this.state.fromAttorney} onChange={this.changeFromAttorney} style={{ width: '200px' }} >
                                            {/* <option value="">Select</option> */}
                                            {this.state.attorneys.map((attorney) => (
                                                <option key={attorney.attorneyId} value={attorney.attorneyId}
                                                >{attorney.attorneyName}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {this.state.tcoOption === 'one' &&
                                        <div className="form-group  mt-1 col" >
                                            <label className=" col"> <b>To Attorney </b>
                                                <b className="float-right " style={{ width: '5%' }}>:</b>
                                            </label>&nbsp;
                                            <select name="attorney" value={this.state.toAttorney} onChange={this.changeToAttorney} style={{ width: '200px' }} >
                                                <option value="">Select</option>
                                                {this.state.attorneys.map((attorney) => (
                                                    this.state.fromAttorney != attorney.attorneyId && <option key={attorney.attorneyId} value={attorney.attorneyId}
                                                    >{attorney.attorneyName}</option>
                                                ))}
                                            </select>
                                            <p className="text-danger" style={{ marginLeft: '28%' }}>{this.state.errorAttorneyNameMessage}</p>
                                        </div>
                                    }
                                </div>
                                <div className='row pt-3'>
                                    <div className="dashboard">
                                        <table className="table table-bordered table-condensed table-striped table-hover table-sm" id="table-dashboard">
                                            <thead className="color">
                                                <tr style={{ borderStyle: 'hidden' }}>
                                                    <th width="25%">Case Name </th>
                                                    <th width="25%">Supervisor</th>
                                                    <th width="20%">From Attorney </th>
                                                    <th width="30%">To Attorney </th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ borderStyle: 'hidden' }}  >
                                                {this.state.refreshFlage && this.state.caseList != null && this.state.caseList.map((cases, index) => (
                                                    <tr key={cases.caseId}>
                                                        <td width="25%">{cases.caseName}</td>
                                                        <td width="25%">{cases.supervisorName}</td>
                                                        <td width="20%">{cases.attorneyName}</td>
                                                        {this.state.tcoOption === 'one' ? <td width="30%">{this.state.toAttorneyName}</td> : <td width="30%">
                                                            <select name="attorney" value={cases.selectedAttorney} onChange={(event) => this.changeCaseToAttorney(event, cases, index)} style={{ width: '200px' }} >
                                                                <option value="">Select</option>
                                                                {this.state.attorneys.map((attorney) => (
                                                                    this.state.fromAttorney != attorney.attorneyId && <option key={attorney.attorneyId} value={attorney.attorneyId}
                                                                    >{attorney.attorneyName}</option>
                                                                ))}
                                                            </select>
                                                            <p className="text-danger">{cases.errorNewAttorneyNameMessage}</p>
                                                        </td>}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    {this.state.totalItems === 0 && <p> No Records are Found.</p>}
                                </div>
                            </div>
                        }

                        <hr></hr>
                        <main>
                            <div className="row mb-2" >
                                <div>
                                    <Link to="/caseSummary"><span
                                        className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Back</span></Link>
                                    <button type="submit"
                                        className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Submit  </button>
                                    <button type="button" onClick={this.showModal}
                                        className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Cancel </button>
                                </div>
                            </div>
                            <CancelModalComponent show={this.state.show} hideModal={() => this.onCloseModal()} cancelChanges={() => this.onCancelChanges()}></CancelModalComponent>
                            <SubmitModalComponent show={this.state.shows} hideModal={() => this.onSubmitModal()} submitChanges={() => this.onSubmitChanges()}></SubmitModalComponent>
                        </main>
                    </div>
                </form>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer
    }
};
export default connect(mapStateToProps)(TransferCases);